export const whoWeAre = {
  lead: 'Universal Packaging Industries LLC manufactures paper cores and stretch film at our plant in the New Industrial Area of Umm Al Quwain.',
  paragraphs: [
    'The business is built on over 25 years of packaging experience.',
    'Alongside what we make, we supply the films, papers, labels and end of line materials our customers order with it. That lets a factory, warehouse or converter source most of its packaging from one place.',
    'We work with customers in the UAE, Oman and Saudi Arabia.',
  ],
};

export const whatWeDo = [
  {
    title: 'Manufacturing',
    text: 'Paper cores in custom sizes and stretch film in hand, machine and power grades.',
    madeByUs: true,
  },
  {
    title: 'Supply',
    text: 'Fluting paper, shrink films, laminates, BOPP and thermoforming films, vacuum bags, casings, labels, sleeves, strapping, tapes and packaging machines.',
    madeByUs: false,
  },
  {
    title: 'Custom printing',
    text: 'Printed versions of laminates, shrink films, sleeves, labels, bags and casings for brands that want their packaging to carry their name.',
    madeByUs: false,
  },
];

export const sectors = [
  'Food producers',
  'Beverage and bottling plants',
  'Film and paper converters',
  'Corrugated box makers',
  'Logistics and warehousing',
  'General manufacturing',
];

export const howWeWork = [
  {
    title: 'Specs first',
    text: 'We ask for dimensions, grade and application before quoting, so what arrives fits your line.',
  },
  {
    title: 'Clear answers',
    text: 'You get product information you can check, not marketing claims.',
  },
  {
    title: 'One supplier',
    text: 'Cores, film and the materials around them from a single contact.',
  },
  {
    title: 'Regional reach',
    text: 'Delivery across the UAE, Oman and Saudi Arabia.',
  },
];
